export const APPROVED = 'active';
export const REJECTED = 'rejected';
export const PERMANENT_REJECTED = 'permanentRejected';
export const PENDING = 'pendingApproval';
export const PENDING_ONLY = 'pending';
export const BANNED = 'banned';
export const RESUBMITTED = 'resubmitted';
export const REJECTED_ONCE = 'Rejected Once';
export const REJECTED_PERMANENT = 'Rejected Permanent';
export const BLOG = 'blog';
export const BLOGS = 'blogs';
export const ARABIC ='ar';
export const ENGLISH ='en';
export const BLOGDETAILS='blog-details'
export const BLOGPHOTOS='blog-photos'

export const userTypeIs = {
  provider: 'tutor',
  customer: 'student',
  user: 'User',
};
// user schema Tutor
const userSchema = {
  "publicData": {
    "aboutMe": "My Bio", // in ProfilePage for bio  
    "country": "USA", // user's country in Profile page
    "education": [    // Tutor's education --> Profile page 
      {
        "description": "description 1",     //education description 
        "endYear": "2024",                  //education start year
        "startYear": "2022",                //education end year
        "title": "title"                    // Education title
      },

    ],
    "languagePreference": "ar",             //Tutor language preference
    "phoneNumber": "1234567890",            // Tutor phone number
    "shortTitle": "Short Title",           // about me with some experience
    "spokenLanguage": [                      // Tutor spoken languages
      {
        "key": "es",
        "label": "Spanish",
        "value": "es"
      },
      {
        "key": "hi",
        "label": "Hindi",
        "value": "hi"
      },
      {
        "key": "en",
        "label": "English",
        "value": "en"
      }
    ],
    "tagline": "Tagline",         //tagline : some motivative line 
    "userType": " User Type : Tutor"
  }
}
// listing schema 
const listingSchema = {
  "publicData": {
    "aboutMe": "My Bio",          //listing bio
    "country": "USA",             // author country
    "education": [                 // author education
      {
        "description": "description 1",
        "endYear": "2024",
        "startYear": "2022",
        "title": "frfrfr"
      },

    ],
    "languagePreference": "ar",     //author language prefernce
    "shortTitle": "Short Title",   // about author with some experience
    "spokenLanguage": [            // Tutor spoken languages
      {
        "key": "es",
        "label": "Spanish",
        "value": "es"
      },
      {
        "key": "hi",
        "label": "Hindi",
        "value": "hi"
      },
      {
        "key": "en",
        "label": "English",
        "value": "en"
      }
    ],
    "tagline": "Tagline",    //tagline : some motivative line
    "certifications": [           // Tutor certifications in language with certicates names and cloudinary links
      {
        "certificateNames": [
          "Platform Notifications and Emails (1)"
        ],
        "certificateUrls": [
          "https://res.cloudinary.com/dnuammhgf/image/upload/v1759929453/users/68e4b463-8419-4b83-b0df-6b0ac9e94628/certifications/yappxw7grglwetzri0kr.pdf"
        ],
        "certificationsDescription": "frfrfrfrf",
        "certificationsEndYear": "2024",
        "certificationsStartYear": "2023",
        "title": "frfrfrffrfrf"
      }
    ],
    "expertise": [           // Tutor extpertise in fileds
      "conversational_arabic",
      "dialects",
      "quranic_arabic",
      "msa"
    ],
    "levels": [              //Tutor language expertise multi check
      "beginner",
      "intermediate"
    ],
    "listingType": "book-seats",
    "priceVariants": [
      {
        "bookingLengthInMinutes": 60,
        "priceInSubunits": 2300
      }
    ],
    "startTimeInterval": "hour",
    "teachingLanguage": "Arabic",
    "transactionProcessAlias": "default-booking/release-1",
    "workExperience": [     //author/ Tutor work experience
      {
        "title": "Title",
        "workExperienceDescription": "Description",
        "workExperienceEndYear": "2022",
        "workExperienceStartYear": "2024"
      }
    ]
  }
}

const walletSchema = {
  sourceId: "e4huh4b4b5465b56bj3b$67878",  // could be orderId, giftCardId, payoutId, etc.
  userId: "userId",   //User's id 
  type: ["credit", "debit"],
  amount: 50,
  balanceBefore: 0, //amount before the credit or debit 
  balanceAfter: 50,//amount after the credit or debit,
  source: [
    "gift_card",
    "deposit",
    "refund",
    "purchase",
    "booking_income",
    "withdrawal",
    "adjustment",
  ],
  status: ["pending", "success", "failed"], //status of the transaction
  metadata: "metaData" // flexible for extra details (refferal id )
}

export const allSpokenLanguages = [
  { value: 'en', key: 'en', label: 'English', label: 'English', label_ar: 'الإنجليزية' },
  { value: 'hi', key: 'hi', label: 'Hindi', label: 'Hindi', label_ar: 'الهندية' },
  { value: 'es', key: 'es', label: 'Spanish', label: 'Spanish', label_ar: 'الإسبانية' },
  { value: 'fr', key: 'fr', label: 'French', label: 'French', label_ar: 'الفرنسية' },
  { value: 'de', key: 'de', label: 'German', label: 'German', label_ar: 'الألمانية' },
  { value: 'zh', key: 'zh', label: 'Chinese (Mandarin)', label: 'Chinese (Mandarin)', label_ar: 'الصينية (الماندارين)' },
  { value: 'ja', key: 'ja', label: 'Japanese', label: 'Japanese', label_ar: 'اليابانية' },
  { value: 'ko', key: 'ko', label: 'Korean', label: 'Korean', label_ar: 'الكورية' },
  { value: 'ar', key: 'ar', label: 'Arabic', label: 'Arabic', label_ar: 'العربية' },
  { value: 'pt', key: 'pt', label: 'Portuguese', label: 'Portuguese', label_ar: 'البرتغالية' },
  { value: 'ru', key: 'ru', label: 'Russian', label: 'Russian', label_ar: 'الروسية' },
  { value: 'it', key: 'it', label: 'Italian', label: 'Italian', label_ar: 'الإيطالية' },
  { value: 'bn', key: 'bn', label: 'Bengali', label: 'Bengali', label_ar: 'البنغالية' },
  { value: 'pa', key: 'pa', label: 'Punjabi', label: 'Punjabi', label_ar: 'البنجابية' },
  { value: 'mr', key: 'mr', label: 'Marathi', label: 'Marathi', label_ar: 'الماراثية' },
  { value: 'te', key: 'te', label: 'Telugu', label: 'Telugu', label_ar: 'التيلجو' },
  { value: 'ta', key: 'ta', label: 'Tamil', label: 'Tamil', label_ar: 'التاميلية' },
  { value: 'ur', key: 'ur', label: 'Urdu', label: 'Urdu', label_ar: 'الأردية' },
  { value: 'gu', key: 'gu', label: 'Gujarati', label: 'Gujarati', label_ar: 'الغوجاراتية' },
  { value: 'ml', key: 'ml', label: 'Malayalam', label: 'Malayalam', label_ar: 'المالايالامية' },
  { value: 'kn', key: 'kn', label: 'Kannada', label: 'Kannada', label_ar: 'الكانادا' },
  { value: 'or', key: 'or', label: 'Odia', label: 'Odia', label_ar: 'الأورية' },
  { value: 'as', key: 'as', label: 'Assamese', label: 'Assamese', label_ar: 'الأسامية' },
  { value: 'ne', key: 'ne', label: 'Nepali', label: 'Nepali', label_ar: 'النيبالية' },
  { value: 'si', key: 'si', label: 'Sinhala', label: 'Sinhala', label_ar: 'السنهالية' },
  { value: 'th', key: 'th', label: 'Thai', label: 'Thai', label_ar: 'التايلاندية' },
  { value: 'tr', key: 'tr', label: 'Turkish', label: 'Turkish', label_ar: 'التركية' },
  { value: 'vi', key: 'vi', label: 'Vietnamese', label: 'Vietnamese', label_ar: 'الفيتنامية' },
  { value: 'fa', key: 'fa', label: 'Persian (Farsi)', label: 'Persian (Farsi)', label_ar: 'الفارسية (فارسي)' },
  { value: 'he', key: 'he', label: 'Hebrew', label: 'Hebrew', label_ar: 'العبرية' },
  { value: 'id', key: 'id', label: 'Indonesian', label: 'Indonesian', label_ar: 'الإندونيسية' },
  { value: 'ms', key: 'ms', label: 'Malay', label: 'Malay', label_ar: 'الملايوية' },
  { value: 'sw', key: 'sw', label: 'Swahili', label: 'Swahili', label_ar: 'السواحيلية' },
  { value: 'nl', key: 'nl', label: 'Dutch', label: 'Dutch', label_ar: 'الهولندية' },
  { value: 'pl', key: 'pl', label: 'Polish', label: 'Polish', label_ar: 'البولندية' },
  { value: 'ro', key: 'ro', label: 'Romanian', label: 'Romanian', label_ar: 'الرومانية' },
  { value: 'uk', key: 'uk', label: 'Ukrainian', label: 'Ukrainian', label_ar: 'الأوكرانية' },
  { value: 'el', key: 'el', label: 'Greek', label: 'Greek', label_ar: 'اليونانية' },
  { value: 'hu', key: 'hu', label: 'Hungarian', label: 'Hungarian', label_ar: 'الهنغارية' },
  { value: 'cs', key: 'cs', label: 'Czech', label: 'Czech', label_ar: 'التشيكية' },
  { value: 'sv', key: 'sv', label: 'Swedish', label: 'Swedish', label_ar: 'السويدية' },
  { value: 'fi', key: 'fi', label: 'Finnish', label: 'Finnish', label_ar: 'الفنلندية' },
  { value: 'da', key: 'da', label: 'Danish', label: 'Danish', label_ar: 'الدانماركية' },
  { value: 'no', key: 'no', label: 'Norwegian', label: 'Norwegian', label_ar: 'النرويجية' },
  { value: 'bg', key: 'bg', label: 'Bulgarian', label: 'Bulgarian', label_ar: 'البلغارية' },
  { value: 'sr', key: 'sr', label: 'Serbian', label: 'Serbian', label_ar: 'الصربية' },
  { value: 'hr', key: 'hr', label: 'Croatian', label: 'Croatian', label_ar: 'الكرواتية' },
  { value: 'sk', key: 'sk', label: 'Slovak', label: 'Slovak', label_ar: 'السلوفاكية' },
  { value: 'sl', key: 'sl', label: 'Slovenian', label: 'Slovenian', label_ar: 'السلوفينية' },
  { value: 'et', key: 'et', label: 'Estonian', label: 'Estonian', label_ar: 'الإستونية' },
  { value: 'lt', key: 'lt', label: 'Lithuanian', label: 'Lithuanian', label_ar: 'الليتوانية' },
  { value: 'lv', key: 'lv', label: 'Latvian', label: 'Latvian', label_ar: 'اللاتفية' },
  { value: 'is', key: 'is', label: 'Icelandic', label: 'Icelandic', label_ar: 'الآيسلندية' },
  { value: 'ga', key: 'ga', label: 'Irish', label: 'Irish', label_ar: 'الأيرلندية' },
  { value: 'cy', key: 'cy', label: 'Welsh', label: 'Welsh', label_ar: 'الويلزية' },
  { value: 'sq', key: 'sq', label: 'Albanian', label: 'Albanian', label_ar: 'الألبانية' },
  { value: 'hy', key: 'hy', label: 'Armenian', label: 'Armenian', label_ar: 'الأرمنية' },
  { value: 'ka', key: 'ka', label: 'Georgian', label: 'Georgian', label_ar: 'الجورجية' },
  { value: 'am', key: 'am', label: 'Amharic', label: 'Amharic', label_ar: 'الأمهرية' },
  { value: 'zu', key: 'zu', label: 'Zulu', label: 'Zulu', label_ar: 'الزولو' },
  { value: 'xh', key: 'xh', label: 'Xhosa', label: 'Xhosa', label_ar: 'الخوسا' },
  { value: 'yo', key: 'yo', label: 'Yoruba', label: 'Yoruba', label_ar: 'اليوروبية' },
  { value: 'ig', key: 'ig', label: 'Igbo', label: 'Igbo', label_ar: 'الإيغبو' },
  { value: 'ha', key: 'ha', label: 'Hausa', label: 'Hausa', label_ar: 'الهوسا' },
  { value: 'mn', key: 'mn', label: 'Mongolian', label: 'Mongolian', label_ar: 'المنغولية' },
  { value: 'km', key: 'km', label: 'Khmer', label: 'Khmer', label_ar: 'الخميرية' },
  { value: 'lo', key: 'lo', label: 'Lao', label: 'Lao', label_ar: 'اللاوية' },
  { value: 'my', key: 'my', label: 'Burmese', label: 'Burmese', label_ar: 'البورمية' },
  { value: 'uz', key: 'uz', label: 'Uzbek', label: 'Uzbek', label_ar: 'الأوزبكية' },
  { value: 'kk', key: 'kk', label: 'Kazakh', label: 'Kazakh', label_ar: 'الكازاخية' },
  { value: 'tg', key: 'tg', label: 'Tajik', label: 'Tajik', label_ar: 'الطاجيكية' },
  { value: 'tk', key: 'tk', label: 'Turkmen', label: 'Turkmen', label_ar: 'التركمانية' },
  { value: 'ps', key: 'ps', label: 'Pashto', label: 'Pashto', label_ar: 'البشتوية' },
  { value: 'ku', key: 'ku', label: 'Kurdish', label: 'Kurdish', label_ar: 'الكردية' },
  { value: 'az', key: 'az', label: 'Azerbaijani', label: 'Azerbaijani', label_ar: 'الأذرية' },
  { value: 'be', key: 'be', label: 'Belarusian', label: 'Belarusian', label_ar: 'البيلاروسية' },
  { value: 'bs', key: 'bs', label: 'Bosnian', label: 'Bosnian', label_ar: 'البوسنية' },
  { value: 'af', key: 'af', label: 'Afrikaans', label: 'Afrikaans', label_ar: 'الأفريكانية' },
  { value: 'eo', key: 'eo', label: 'Esperanto', label: 'Esperanto', label_ar: 'الإسبرانتو' },
  { value: 'la', key: 'la', label: 'Latin', label: 'Latin', label_ar: 'اللاتينية' },
  { value: 'mi', key: 'mi', label: 'Maori', label: 'Maori', label_ar: 'الماورية' },
  { value: 'sm', key: 'sm', label: 'Samoan', label: 'Samoan', label_ar: 'الساموية' },
  { value: 'fj', key: 'fj', label: 'Fijian', label: 'Fijian', label_ar: 'الفيجية' },
  { value: 'so', key: 'so', label: 'Somali', label: 'Somali', label_ar: 'الصومالية' },
  { value: 'tt', key: 'tt', label: 'Tatar', label: 'Tatar', label_ar: 'التترية' },
  { value: 'ky', key: 'ky', label: 'Kyrgyz', label: 'Kyrgyz', label_ar: 'القيرغيزية' },
  { value: 'taq', key: 'taq', label: 'Tamasheq', label: 'Tamasheq', label_ar: 'التماشق' },
  { value: 'rw', key: 'rw', label: 'Kinyarwanda', label: 'Kinyarwanda', label_ar: 'الكينيارواندية' },
  { value: 'ln', key: 'ln', label: 'Lingala', label: 'Lingala', label_ar: 'اللينغالا' },
  { value: 'sn', key: 'sn', label: 'Shona', label: 'Shona', label_ar: 'الشونا' },
  { value: 'ny', key: 'ny', label: 'Chichewa', label: 'Chichewa', label_ar: 'الشيشيوا' },
  { value: 'st', key: 'st', label: 'Sesotho', label: 'Sesotho', label_ar: 'السيسوتو' },
  { value: 'ts', key: 'ts', label: 'Tsonga', label: 'Tsonga', label_ar: 'التسونغا' },
  { value: 'tn', key: 'tn', label: 'Tswana', label: 'Tswana', label_ar: 'التسوانية' },
];
export const expertiseList = [
  {
    value: 'conversational_arabic',
    key: 'conversational_arabic',
    label_en: 'Conversational Arabic',
    label_ar: 'العربية المحكية',
  },
  { value: 'dialects', key: 'dialects', label_en: 'Dialects', label_ar: 'اللهجات' },
  {
    value: 'quranic_arabic',
    key: 'quranic_arabic',
    label_en: 'Quranic Arabic',
    label_ar: 'العربية القرآنية',
  },
  { value: 'msa', key: 'msa', label_en: 'MSA', label_ar: 'العربية الفصحى الحديثة' },
  {
    value: 'business_arabic',
    key: 'business_arabic',
    label_en: 'Business Arabic',
    label_ar: 'العربية للأعمال',
  },
  { value: 'exam_prep', key: 'exam_prep', label_en: 'Exam Prep', label_ar: 'التحضير للامتحانات' },
]
export const levelsList = [
  { value: 'beginner', key: 'beginner', label_en: 'Beginner', label_ar: 'مبتدئ' },
  { value: 'intermediate', key: 'intermediate', label_en: 'Intermediate', label_ar: 'متوسط' },
  { value: 'advanced', key: 'advanced', label_en: 'Advanced', label_ar: 'متقدم' },
];

export const ageGroupList = [
  { value: 'kids', key: 'kids', label_en: 'Kids(6-10)', label_ar: 'الأطفال (6-10)' },
  { value: 'teenagers', key: 'teenagers', label_en: 'Teenagers(10-16)', label_ar: 'المراهقون (10-16)' },
  { value: 'adults', key: 'adults', label_en: 'Adults(16+)', label_ar: 'البالغون (16+)' },
];


export const specializationsList = [
  { value: 'conversational_arabic', key: 'conversational_arabic', label_en: 'Conversational Arabic', label_ar: 'العربية المحكية' },
  { value: 'quranic_arabic', key: 'quranic_arabic', label_en: 'Quranic Arabic', label_ar: 'العربية القرآنية' },
  { value: 'business_arabic', key: 'business_arabic', label_en: 'Business Arabic', label_ar: 'العربية للأعمال' },
];


// Pricing panel: session length options (in minutes)
export const SESSION_TIME_MINUTES = [50];
// Explicit options with human-readable labels
export const SESSION_TIME_OPTIONS = [

  { value: 50, label_en: '50 Min Session', label_ar: 'جلسة 50 دقيقة' },

];

// Pricing panel: session price categories
export const SESSION_PRICE_CATEGORIES = ['beginner', 'intermediate', 'advanced'];
// Explicit options with human-readable labels
export const SESSION_PRICE_CATEGORY_OPTIONS = [
  { value: 'beginner', label_en: 'Beginner ($10–15)', label_ar: 'مبتدئ (10–15$)' },
  { value: 'intermediate', label_en: 'Intermediate ($15–20)', label_ar: 'متوسط (15–20$)' },
  { value: 'advanced', label_en: 'Advanced ($20–25)', label_ar: 'متقدم (20–25$)' },
];


// tags 
export const tagsList = [
  { key: 'arabic_tutor', label_en: 'Arabic tutor', label_ar: 'مدرس عربي' },
  { key: 'msa_vs_dialects', label_en: 'MSA vs. Dialects', label_ar: 'العربية الفصحى مقابل اللهجات' },
  { key: 'learning', label_en: 'Learning', label_ar: 'التعلم' },
  { key: 'learning_resources', label_en: 'Learning Resources', label_ar: 'موارد التعلم' },
]

  // Countries that use IBAN
  export const IBAN_COUNTRIES = [
    'AD', 'AT', 'AZ', 'BH', 'BE', 'BA', 'BG', 'CR', 'HR', 'CY', 'CZ', 'DK',
    'DO', 'EE', 'FO', 'FI', 'FR', 'GE', 'DE', 'GI', 'GR', 'GL', 'GT', 'HU',
    'IS', 'IE', 'IL', 'IT', 'JO', 'KZ', 'KW', 'LV', 'LB', 'LI', 'LT', 'LU',
    'MK', 'MT', 'MR', 'MU', 'MC', 'MD', 'ME', 'NL', 'NO', 'PK', 'PS', 'PL',
    'PT', 'QA', 'RO', 'SM', 'SA', 'RS', 'SK', 'SI', 'ES', 'SE', 'CH', 'TN',
    'TR', 'AE', 'GB', 'VA', 'XK'
  ];
  // Countries with special banking systems
  export const SPECIAL_COUNTRIES = {
    US: {
      system: 'aba',
      fields: ['routingNumber', 'accountNumber'],
      currency: 'USD'
    },
    IN: {
      system: 'ifsc',
      fields: ['ifscCode', 'accountNumber', 'branchName'],
      currency: 'INR'
    },
    AU: {
      system: 'bsb',
      fields: ['bsbNumber', 'accountNumber'],
      currency: 'AUD'
    },
    CA: {
      system: 'transit',
      fields: ['institutionNumber', 'transitNumber', 'accountNumber'],
      currency: 'CAD'
    },
    NZ: {
      system: 'nz',
      fields: ['bankNumber', 'branchNumber', 'accountNumber'],
      currency: 'NZD'
    },
    CN: {
      system: 'cn',
      fields: ['bankCode', 'accountNumber', 'branchName'],
      currency: 'CNY'
    },
    HK: {
      system: 'hk',
      fields: ['bankCode', 'branchCode', 'accountNumber'],
      currency: 'HKD'
    },
    SG: {
      system: 'sg',
      fields: ['bankCode', 'branchCode', 'accountNumber'],
      currency: 'SGD'
    },
    JP: {
      system: 'jp',
      fields: ['bankCode', 'branchCode', 'accountNumber'],
      currency: 'JPY'
    },
    KR: {
      system: 'kr',
      fields: ['bankCode', 'accountNumber'],
      currency: 'KRW'
    },
    BR: {
      system: 'br',
      fields: ['bankCode', 'branchCode', 'accountNumber'],
      currency: 'BRL'
    },
    RU: {
      system: 'ru',
      fields: ['bik', 'accountNumber', 'correspondentAccount'],
      currency: 'RUB'
    },
    MX: {
      system: 'mx',
      fields: ['clabe', 'accountNumber'],
      currency: 'MXN'
    },
    ZA: {
      system: 'za',
      fields: ['branchCode', 'accountNumber'],
      currency: 'ZAR'
    }
  };

export const currencyMap = {
  SA: 'SAR', AE: 'AED', GB: 'GBP', EU: 'EUR', JP: 'JPY', CN: 'CNY', HK: 'HKD', SG: 'SGD',
  KR: 'KRW', BR: 'BRL', RU: 'RUB', MX: 'MXN', ZA: 'ZAR', CH: 'CHF', SE: 'SEK', NO: 'NOK',
  DK: 'DKK', IN: 'INR', US: 'USD', AU: 'AUD', CA: 'CAD', NZ: 'NZD'
};
